import { render } from "./Slider.vue?vue&type=template&id=67712f96"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"

import "./Slider.vue?vue&type=style&index=0&id=67712f96&lang=scss"

import exportComponent from "/var/www/sites/qiyas.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__